import { render, staticRenderFns } from "./Dove.vue?vue&type=template&id=196a9a4b&scoped=true&"
var script = {}
import style0 from "./Dove.vue?vue&type=style&index=0&id=196a9a4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a9a4b",
  null
  
)

export default component.exports